import dashboard from './dashboard'
import notes from './notes'

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard]
}

export default menuItems
